<script setup>
import HomeSvg from "@/components/UI/svg/HomeSvg.vue";
import {defineModel} from 'vue'
import AccountSvg from "@/components/UI/svg/AccountSvg.vue";
import {useRouter} from "vue-router";

const isVisible = defineModel()

const router = useRouter()


function closeMenu() {
    isVisible.value = false
}

function redirectToAccount() {
    router.push("/me")
}

</script>

<template>
 <div
     class="w-full h-screen absolute z-20 flex flex-col bottom-0"
     :class="{
        'invisible': !isVisible,
        'visible': isVisible,
     }"
 >
     <div class="w-full h-full bg-transparent-gray" v-on:click="closeMenu"></div>
     <div class="bg-white w-full flex flex-col">
         <div class="h-7 w-full flex items-center cursor-pointer"></div>
         <div class="h-14 w-full flex items-center cursor-pointer">
             <HomeSvg class="size-6 fill-blue-500 ml-10 mr-5" />
             <div class="font-bold text-blue-500 text-sm">
                 Рабочая область
             </div>
         </div>
         <div class="h-14 w-full flex items-center cursor-pointer" v-on:click="redirectToAccount">
             <AccountSvg class="size-6 stroke-black ml-10 mr-5"  />
             <div class="font-bold text-black text-sm">
                 Аккаунт
             </div>
         </div>
         <div class="h-7 w-full flex items-center cursor-pointer"></div>
     </div>
 </div>
</template>

<style scoped>
.bg-transparent-gray {
    background-color: rgba(115, 115, 115, 0.2);
}
</style>